<template>
  <div class="CoverageComplete">
    <div class="choice-row">
      <div
        class="mandatory-box"
        v-if="isMandatory"
      >
        <i class="icon-check-02" />

        <p>{{ text }}</p>
      </div>

      <BaseCheckBox
        v-else
        :id="id"
        :label="text"
        v-model="checked"
      />

      <BaseTooltip
        v-if="tooltip"
        :text="tooltip"
      />
    </div>

    <FormField
      v-if="checked && hasCapitals && capital !== null"
      :statement="
        t('copy_life_modify-insurance_coverages-title', {
          min: addCommas(minCapital!),
          max: addCommas(maxCapital!)
        })
      "
    >
      <AdvantageSliderComponent
        :id="`${id}-slider`"
        v-model="capital"
        :min="minCapital!"
        :max="maxCapital!"
        :step="capitals[0] - capitals[1]"
        :footer-message="capitalsFooter"
      />
    </FormField>
  </div>
</template>

<script setup lang="ts">
import BaseCheckBox from '@/modules/core/components/ui/BaseCheckBox.vue'
import BaseTooltip from '@/modules/core/components/ui/BaseTooltip.vue'
import AdvantageSliderComponent from '@/modules/core/components/utils/AdvantageSliderComponent.vue'
import FormField from '@/modules/core/components/utils/FormField.vue'
import { addCommas } from '@/utils/textUtils'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface PropsInterface {
  id: string
  isMandatory?: boolean
  text: string
  tooltip?: string
  capitals?: number[]
}
const props = withDefaults(defineProps<PropsInterface>(), {
  isMandatory: false,
  capitals: () => []
})

const checked = defineModel<boolean>('checked', { required: true })
const capital = defineModel<number | null>('capital')
const hasCapitals = computed(() => props.capitals.length > 0)
const minCapital = computed(() => (hasCapitals.value ? Math.min(...props.capitals) : null))
const maxCapital = computed(() => (hasCapitals.value ? Math.max(...props.capitals) : null))
const capitalsFooter = computed(() => {
  const options = [...props.capitals].sort().map((c) => addCommas(c))
  const last = options.pop()
  const previous = options.join(', ')

  return t(`copy_common_slider-footer_options`, { previous, last })
})

// watch(checked, (value: boolean) => {
//   console.log('CoverageComplete: checked changed', value)
//   console.log('CoverageComplete: capital before change', capital.value)
//   if (value) {
//     capital.value ??= minCapital.value
//   } else {
//     capital.value = null
//   }
//   console.log('CoverageComplete: capital after change', capital.value)
// })
</script>

<style lang="scss" scoped>
.CoverageComplete {
  display: grid;
  gap: $gap-l;

  .choice-row {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: $gap-s;

    .mandatory-box {
      i {
        font-size: 1.4rem;
      }

      p {
        color: $color-black-200;
      }

      display: flex;
      align-items: center;
      gap: $gap-s;
    }
  }
}
</style>
